import { ActionReducer, INIT, MetaReducer } from '@ngrx/store';
import * as AuthStoreActions from 'mbs-ui-shared@store/auth/actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function logout(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => action?.type === AuthStoreActions.logout.type ? reducer(undefined, { type: INIT }) : reducer(state, action)
}

export const metaReducers: MetaReducer[] = [logout];
